<template>
    <view-card headline="관리자메모" pb="0" :disabled="!isAdmin">
        <v-textarea hide-details class="py-0" v-model="adminMemo" rows="12" />
        <v-card-actions slot="actions" class="pt-0 px-4 pb-4">
            <v-row justify="end">
                <v-col cols="auto" class="py-0">
                    <v-btn small color="primary" @click="$emit('clickSave', { measurementInfo: { adminMemo } })">저장</v-btn>
                </v-col>
            </v-row>
        </v-card-actions>
    </view-card>
</template>
<script>
import viewCard from "../dumb/view-card.vue";
export default {
    components: { viewCard },
    props: {
        value: { type: String, default: null },
        isAdmin: { type: Boolean, default: false },
    },
    data() {
        return {
            adminMemo: {},
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.adminMemo = JSON.parse(JSON.stringify(this.value));
        },
    },
    watch: {
        value() {
            this.init();
        },
    },
};
</script>
